import { Component, OnInit, Output } from '@angular/core';
import {Router, ActivatedRoute, Event, NavigationEnd, NavigationError} from '@angular/router';
import {NewsSharedService} from "../../../common-main/services/news-shared.service";
import {DomSanitizer} from '@angular/platform-browser';
import {EmbedVideoService} from 'ngx-embed-video';
import {LangChange} from "../../../../lang-change";
import {Language} from "../../../../common/models/language";
import {TranslateService} from '@ngx-translate/core';
import {EventEmitter} from 'events';
import {Principal} from "../../../../common/services/principal";
import {PageDTO} from "../../../../common/dtos/PageDTO";
import {Utils} from "../../../../common/services/Utils";
import {NewsStatusesENUM} from "../../../../common/enums/news-statuses.enum";
import {Events} from "../../../admin/components/events/events";
import {NewsService} from "../../../moderator/services/news.service";
import {News} from "../../../moderator/components/add-edit-news/model/news";

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent extends LangChange implements OnInit {
  page: PageDTO = new PageDTO();
  isModerator = false;
  newsSectionModerators: any[] = [];
  newsList: any[] = [];
  lastNews: any[];
  events: Events[];
  totalElements = 0;
  newsStatus: string = NewsStatusesENUM.PUBLISHED;
  tagId: number;
  tagName: any = {name: ""};
  @Output() valueChange = new EventEmitter();

  constructor(private _router: Router,
              private route: ActivatedRoute,
              private _principal: Principal,
              public _translateService: TranslateService,
              private newsSharedService: NewsSharedService,
              private _utils: Utils,
              private embedService: EmbedVideoService,
              private sanitizer: DomSanitizer,
              private newsService: NewsService) {
    super(_translateService);
    _router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.route.params.subscribe(params => {
          this.tagId = +params['tagId'];
          this.getTagInfoById();
        });
        this.page.filter = {search: null, status: this.newsStatus, tag: this.tagId};
        this.page.size = 5;
        this.getPublishedNewsList(true);
      }
      if (event instanceof NavigationError) {
        console.log(event.error);
      }
    });
  }

  ngOnInit() {
    this.tagId = null;
    this.route.params.subscribe(params => {
      this.tagId = +params['tagId'];
    });

    if (this._principal.isLoggedIn()) {
      this.newsService.getNewsSectionModerators().subscribe(data => {
        if (data) {
          this.newsSectionModerators = data;
          this.isModerator = this.newsSectionModerators.indexOf(this._principal.getUserId()) > -1;
        }
      });
    }

    this.loadLastNews();
    this.getPublishedNewsList(true);
  }

  onLangChange(language: Language): void {
  }

  getTagInfoById() {
    let params: PageDTO = new PageDTO();
    params.filter = {search: null, tag: this.tagId};
    this.newsSharedService.getTagInfo(params).subscribe(data => {
      if(data) {
        this.tagName = data;
      }
    });
  }

  loadLastNews() {
    this.newsSharedService.getLastNews().subscribe(data => {
      if (data) {
        this.lastNews = data;
        // this.fillNewsList(data);
      }
    });
  }

  reloadList(resetPage) {
    if (resetPage) {
      this.page.pageNumber = 0;
    }
    switch (this.newsStatus) {
      case NewsStatusesENUM.SAVED : this.getSavedNewsList(false); break;
      case NewsStatusesENUM.PUBLISHED : this.getPublishedNewsList(false); break;
      case NewsStatusesENUM.ARCHIVED : this.getArchivedNewsList(false); break;
    }
  }

  getSavedNewsList(resetPage) {
    this.newsStatus = NewsStatusesENUM.SAVED;
    this.page.filter = {search: null, status: this.newsStatus};
    if (resetPage) this.page.pageNumber = 0;
    this.newsSharedService.getNewsListByStatus(this.page).subscribe(data => {
      if (data) {
        this.fillNewsList(data.dtoList);
        this.totalElements = data.totalElements;
      }
    });

  }

  getPublishedNewsList(resetPage) {
    this.newsStatus = NewsStatusesENUM.PUBLISHED;
    this.page.filter = {search: null, status: this.newsStatus, tag: this.tagId};
    if (resetPage) this.page.pageNumber = 0;
    this.newsSharedService.getNewsListByStatus(this.page).subscribe(data => {
      if (data) {
        this.fillNewsList(data.dtoList);
        this.totalElements = data.totalElements;
      }
    });
  }

  getArchivedNewsList(resetPage) {
    this.newsStatus = NewsStatusesENUM.ARCHIVED;
    this.page.filter = {search: null, status: this.newsStatus};
    if (resetPage) this.page.pageNumber = 0;
    this.newsSharedService.getNewsListByStatus(this.page).subscribe(data => {
      if (data) {
        this.fillNewsList(data.dtoList);
        this.totalElements = data.totalElements;
      }
    });
  }


  fillNewsList(data: any[]) {
    this.newsList = [];
    this._utils.blockStart(null);
    for(let item of data) {
      if (item.id){
        if (item.newsImageIdKz) {
          this.newsSharedService.getNewsImage(item.id, item.newsImageIdKz).subscribe(data => {
            item.newsImageIdKz = window.URL.createObjectURL(new Blob([data], {type: data.type}));
            item.newsVideoLinkKz = null;
          }, error => {console.log('getFile error', error);});
        }
        if (item.newsImageIdRu) {
          this.newsSharedService.getNewsImage(item.id, item.newsImageIdRu).subscribe(data => {
            item.newsImageIdRu = window.URL.createObjectURL(new Blob([data], {type: data.type}));
            item.newsVideoLinkRu = null;
          }, error => {console.log('getFile error', error);});
        }
        if (item.newsImageIdEn) {
          this.newsSharedService.getNewsImage(item.id, item.newsImageIdEn).subscribe(data => {
            item.newsImageIdEn = window.URL.createObjectURL(new Blob([data], {type: data.type}));
            item.newsVideoLinkEn = null;
          }, error => {console.log('getFile error', error);});
        }
      }
      item.newsContentKz = item.newsContentKz + '...';
      item.newsContentRu = item.newsContentRu + '...';
      item.newsContentEn = item.newsContentEn + '...';
      this.newsList.push(item);
    }
    setTimeout(() => {
      this._utils.blockStop();
    }, (data.length > 1 ? 1000 : 100));
    // console.log('fillNewsList', this.newsList);
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getVideoFrame(newsVideoLink) {
    return this.embedService.embed(newsVideoLink);
  }

  gotoNews(id) {
    if (id && typeof id === 'string') {
      this._router.navigate(['news', id]);
    }
  }

  editNews(id){
    if (id && typeof id === 'string') {
      this._router.navigate(['moderator/add-edit-news/' + id]);
    }
  }

  getNewByTagId(id) {
    if (id) {
      this._router.navigate(['/news/tag/' + id]);
    }
  }

  resetTags() {
    // console.log('resetTags');
    this._router.navigate(['/news/']);
  }

  changeValue() {
    this.valueChange.emit('');
  }

  checkIsNewsModerator(newsItem: News) {
    if (newsItem.creatorId && this._principal.isLoggedIn()) {
      // return newsItem.creatorId === this._principal.getUserId() && this.isModerator;
      return this.isModerator;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/news/news.component.ts